<template>
  <div id="topDiv">
    <a @click="showCityDialog" style="font-size:13px;cursor: pointer;color:gray">全部城市</a>
    <el-dialog
      title="请选择城市"
      :visible.sync="showCity"
      ref="dialog"
      custom-class="mydialog"
      :before-close="handleClose"
    >
      <div class="city">
        <div class="city-components">
          <ul class="filter-tabar clearfix" style="background-color: rgb(250,250,250);">
            <li
              style="padding-left:25px"
              :class="{active:upCityListIndex==-1}"
              @click="upCityListIndex = -1"
            >热门城市</li>
            <li
              style="margin-left:50px;"
              v-for="(item,index) in cityListKey"
              :class="{active:upCityListIndex==index}"
              @click="upCityListKey(index)"
            >{{item}}</li>
          </ul>
          <div class="city-content">
            <ul
              v-if="upCityListIndex == -1"
              v-for="(item,index) in this.$store.state.chinadata.hotCitys"
              class="clearfix"
              style="margin-left:56px;float:left"
            >
              <li @click="selectDepCity(item,index)">{{item.name}}</li>
            </ul>
            <ul
              v-if="upCityListIndex != -1"
              v-for="item in upCityList"
              class="clearfix"
              style="margin-left:36px"
            >
              <label for>{{item.ckey}}</label>
              <li v-for="ritem in item.cityList" @click="selectDepCity(ritem,-1)">{{ritem.name}}</li>
            </ul>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getAction } from "../comm/manage";

export default {
  name: "app",
  data() {
    return {
      showCity: false,
      url: {
        list: "/chinadata/tsChinaDataLeave/list",
      },
      dataList: [],
      upCityListIndex: "-1",
      upCityList: "",
    };
  },
  computed: {
    cityListData() {
      let map = {}; // 处理过后的数据对象
      let temps = []; // 临时变量
      this.dataList.map((item) => {
        if (item.pinyin) {
          let ekey = item.pinyin.charAt(0).toUpperCase(); // 根据key值的第一个字母分组，并且转换成大写
          temps = map[ekey] || []; // 如果map里面有这个key了，就取，没有就是空数组
          temps.push({
            pinyin: item.pinyinPrefix,
            name: item.name,
            id: item.id,
            cid: item.cid,
            pid: item.pid,
            deep: item.deep,
          });
          map[ekey] = temps;
        }
      });
      let list = [];
      for (let gkey in map) {
        list.push({
          ckey: gkey,
          cityList: map[gkey],
        });
      }
      list = list.sort(
        (li1, li2) => li1.ckey.charCodeAt(0) - li2.ckey.charCodeAt(0)
      );
      let result = [];
      result.push(list.slice(0, 5));
      result.push(list.slice(5, 9));
      result.push(list.slice(9, 13));
      result.push(list.slice(13, 18));
      result.push(list.slice(18, 22));
      return result;
    },
    cityListKey() {
      let cityListKey = [];
      this.cityListData.map((item) => {
        let ckeys = "";
        item.map((ritem) => {
          ckeys += ritem.ckey;
        });
        cityListKey.push(ckeys);
      });
      this.upCityList = this.cityListData[0];
      return cityListKey;
    },
  },
  mounted() {
    let params = {
      pageSize: 1000,
      deep: "1",
    };
    this.loadData(params);
  },
  methods: {
    loadData(params) {
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataList = res.result.records;
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
      });
    },
    upCityListKey(index) {
      this.upCityListIndex = index;
      this.upCityList = this.cityListData[index];
    },
    hideCityDialog() {
      this.showCity = false;
    },
    showCityDialog() {
      this.showCity = true;
    },
    handleClose(done) {
      done();
    },
    selectDepCity(item,index) {
      if (item.name == "全国") {
        this.$store.commit("SET_SELECTEDAREAS", []);
        this.$store.commit("SET_SUBAREAS", []);
      } else {
        let params = {
          pageSize: 1000,
          pid: item.cid,
          name: item.name,
        };
        this.$store.commit("SET_INITACTIVE", index);
        this.$emit('selectCity',item,index);
        this.$store.dispatch("loadSubAreas", params);
        let objSelected = [
          { cid: item.cid, name: item.name },
          { cid: "", name: "不限" }
        ];
        this.$store.commit("SET_SELECTEDAREAS", objSelected);
      }
      this.showCity = false;
    },
  },
};
</script>
<style>
.mydialog > div:nth-child(1) {
  text-align: left;
  padding: 8px 0px 0px 15px;
}
.mydialog > div:nth-child(2) {
  padding-left: 0px;
  padding-right: 0px;
}
</style>
<style scoped lang="scss">
#topDiv {
  z-index: 99999;
}
* {
  margin: 0;
  padding: 0;
}
.city-wap {
  color: #387cbb;

  .clearfix {
    &:after {
      content: "";
      display: block;
      clear: both;
    }
  }
  p {
    background: #fff;
    margin-bottom: 10px;
    padding: 0 12px;
  }
  .search {
    position: fixed;
    top: 0;
    box-shadow: 0 1px 3px 0 rgba(59, 79, 98, 0.1);
    width: 100%;
    height: 50px;
    input {
      line-height: 50px;
      width: 100%;
      border: none;
      box-shadow: none;
      padding: 0 10px;
      &:focus {
        outline: none;
      }
    }
  }
  .city-list {
    .block-60 {
      height: 60px;
    }
    ul {
      padding: 0 10px;
      li {
        list-style: none;
        display: inline-block;
        margin-right: 10px;
        width: 29%;
        margin-bottom: 8px;
        line-height: 35px;
        text-align: center;
        color: #333;
        border-radius: 3px;
        background: #fff;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 0 2px;
      }
    }
  }
  .filter {
    position: fixed;
    right: 3px;
    top: 60px;
    font-size: 15px;
    div {
      margin-top: 2px;
      text-align: center;
    }
  }
  .active-key {
    position: fixed;
    width: 100px;
    height: 100px;
    line-height: 100px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
    background: #dedede;
    color: #fff;
    border-radius: 100%;
    text-align: center;
    font-size: 40px;
  }
}
.city {
  position: relative;
  width: 100%;
  height: 500px;
  margin-bottom: 35px;
  text-align: left;
  font-size: 14px;
  .city-components {
    background: white;
    z-index: 99990;
    position: absolute;
    width: 100%;
    border-radius: 2px;
    .clearfix {
      &:after {
        content: "";
        display: block;
        clear: both;
      }
    }
    li {
      list-style: none;
    }
    ul {
      padding: 0 0 0 10px;
      margin: 0;
    }
    .filter-tabar {
      border-bottom: 1px solid #d7d7d7;
      cursor: pointer;
      li {
        text-align: center;
        padding: 0 14px;
        float: left;
        padding-bottom: 14px;
        margin: 0 8px;
        margin-bottom: -1px;
        position: relative;
        &.active {
          border-bottom: 2px solid #f82b17;
          color: #f82b17;
        }
      }
    }
    .city-content {
      max-height: 500px;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 10px 13px 0 0px;
      label {
        display: block;
        margin-bottom: 5px !important;
        margin-left: 0 !important;
        color: #5f5f5f !important;
        margin-top: 5px;
      }
      li {
        padding: 6px 0 6px;
        float: left;
        text-align: left;
        min-width: 56px;
        margin-right: 24px;
        cursor: pointer;
        padding-bottom: 25px;
      }
    }
  }
}
</style>